/*
 * Session du CRM. Les règles d'accès de la base (is_crm_admin) n'autorisent que le compte info@sunisup.be :
 * sans cette session (déconnexion automatique, déconnexion depuis un autre onglet, autre compte), la base
 * ne renvoie aucune fiche et n'en modifie aucune, sans message d'erreur. Ce module traduit ce cas.
 */
import { supabase } from '../../lib/supabase';

export const CRM_ADMIN_EMAIL = 'info@sunisup.be';

export const SESSION_EXPIRED_MESSAGE =
  'Session expirée : reconnectez-vous (déconnexion automatique ou depuis un autre onglet). La modification n’a pas été enregistrée.';

/** Problème de session pour le CRM, ou null si le compte info@sunisup.be est connecté. */
export async function crmSessionProblem(): Promise<string | null> {
  const { data } = await supabase.auth.getSession();
  const email = (data?.session?.user?.email ?? '').toLowerCase();
  if (!email) return SESSION_EXPIRED_MESSAGE;
  if (email !== CRM_ADMIN_EMAIL) return `Connecté avec ${email} : le CRM n’est modifiable qu’avec le compte ${CRM_ADMIN_EMAIL}.`;
  return null;
}

/**
 * Aucune ligne modifiée par une mise à jour (`.update().eq('id', …)`) : session perdue, fiche supprimée
 * ou refus de la base. `what` : « Fiche », « Fiche participant »…
 */
export async function noRowError(table: string, id: string, what: string): Promise<Error> {
  const problem = await crmSessionProblem().catch(() => null);
  if (problem) return new Error(problem);
  const { data } = await supabase.from(table).select('id').eq('id', id).maybeSingle();
  if (!data) return new Error(`${what} introuvable : elle a peut-être été supprimée ou fusionnée. Actualisez le CRM.`);
  return new Error(`${what} non modifiée : la base a refusé l’enregistrement. Actualisez le CRM et réessayez.`);
}
